import React, { useEffect, useState } from "react";
import Select from "react-select";
import { listDefaultBenefits } from "./Axios";

const DefaultBenefitsSelector = ({ onPick }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    listDefaultBenefits()
      .then(({ data }) => {

        if (!Array.isArray(data)) {
          setOptions([]);
          return;
        }

        const opts = data.map(b => ({
          value: b.id,
          label: b.title,
          content: b.content
        }));

        setOptions(opts);
      })
      .catch(err => {
      });
  }, []);

  return (
    <Select
      placeholder="Agregar beneficio predeterminado…"
      options={options}

      onChange={opt => {
        if (opt) onPick(opt);
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          backgroundColor: '#fff',
          zIndex: 9999,
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? '#f0f0f0'
            : state.isFocused
              ? '#f8f9fa'
              : '#fff',
          color: '#222',
        }),
      }}
    />
  );
};


export default DefaultBenefitsSelector;
